import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { Draft, produce } from 'immer'
import {
  ColorPickerButton,
  IColorPickerButtonData,
  IPreviousColorPickerButtonData,
  TypeColorPickerEnum,
} from '../../../hooks/colorPicker/types'

export const stateDefaultColorPickerButton: ColorPickerButton = {
  current: {},
  previous: {},
}

const colorPickerButtonSlice = createSlice({
  name: 'colorPickerButton',
  initialState: stateDefaultColorPickerButton,
  reducers: {
    setColorPicker: (state, action: PayloadAction<IColorPickerButtonData>) => {
      return produce(state, (draft: Draft<ColorPickerButton>) => {
        if (draft[TypeColorPickerEnum.PREVIOUS]) draft.previous = {}

        draft[TypeColorPickerEnum.CURRENT][action.payload.key] =
          action.payload.color
      })
    },
    setColorPickerSuggestion: (
      state,
      action: PayloadAction<IPreviousColorPickerButtonData>
    ) => {
      return produce(state, (draft: Draft<ColorPickerButton>) => {
        draft[TypeColorPickerEnum.PREVIOUS] = draft.current
        draft[TypeColorPickerEnum.CURRENT] = action.payload
      })
    },
    resetColorPickerSuggestion: (state) => {
      return produce(state, (draft: Draft<ColorPickerButton>) => {
        if (!draft[TypeColorPickerEnum.PREVIOUS]) return

        draft[TypeColorPickerEnum.CURRENT] = draft.previous
        draft[TypeColorPickerEnum.PREVIOUS] = {}
      })
    },
  },
})

export const {
  setColorPicker,
  setColorPickerSuggestion,
  resetColorPickerSuggestion,
} = colorPickerButtonSlice.actions
export default colorPickerButtonSlice
